import React from "react";
import { Box, List, Typography } from "@mui/material";
import SidebarItem from "./SidebarItem";
import { MENU_GROUPS } from "../../constants/menu";
import LogoutIcon from "@mui/icons-material/Logout";

import { SidebarProps } from "../../types/";
import { APP_STRINGS, MENU_STRINGS } from "../../constants/strings";

import "./sidebar.css";

// 🔥 Redux
import { useDispatch } from "react-redux";
import { logout } from "../../store/authSlice";

// 🔥 Router
import { useNavigate } from "react-router-dom";

const Sidebar: React.FC<SidebarProps> = ({ collapsed }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logout());      // ✅ Redux clear
    navigate("/login");      // ✅ SPA navigation
  };

  return (
    <Box className={`sidebar ${collapsed ? "collapsed" : ""}`}>
      {/* TOP */}
      <Box className="sidebar-inner">
        {!collapsed && (
          <>
            <Typography className="sidebar-logo">
              {APP_STRINGS.APP_NAME}
            </Typography>
            <Box className="sidebar-divider" />
          </>
        )}

        {/* MENU */}
        <List className="sidebar-menu">
          {MENU_GROUPS.map((group, index) => (
            <Box key={index}>
              {!collapsed && group.title && (
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: 600,
                    color: "var(--text-secondary)",
                    px: 1,
                    mb: 1,
                    mt: index !== 0 ? 2 : 0,
                  }}
                >
                  {group.title}
                </Typography>
              )}

              {group.items.map((item) => (
                <SidebarItem
                  key={item.path}
                  {...item}
                  collapsed={collapsed}
                />
              ))}

              {index !== MENU_GROUPS.length - 1 && (
                <Box className="sidebar-divider" />
              )}
            </Box>
          ))}
        </List>
      </Box>

      {/* BOTTOM */}
      <Box className="sidebar-bottom">
        <Box className="sidebar-divider" />

        <SidebarItem
          label={MENU_STRINGS.LOGOUT}
          path="#"
          icon={LogoutIcon}
          collapsed={collapsed}
          onClick={handleLogout}
        />
      </Box>
    </Box>
  );
};

export default Sidebar;